<template>
  <div
    class="h-full relative overflow-hidden flex flex-col justify-center items-center"
  >
    <div class="w-full flex flex-row justify-center items-center mt-20">
      <div
        class="w-5/12 flex flex-col justify-center 2xl:items-end lg:items-center"
      >
        <div class="w-7/12 flex justify-center">
          <span
            class="w-208 h-3.5 text-center bg-vivid-pink font-mulish-bold text-white text-2 leading-2.2 tracking-wider px-2 flex items-center justify-center"
            >3. Guild Window</span
          >
        </div>
        <img
          class="mt-9 2xl:w-7/12 lg:w-10/12"
          :src="`${imgPath}/SystemChanges/guildrework_3.png`"
          alt="awakening"
        />
      </div>
      <div
        class="2xl:ml-12 xl:ml-0 2xl:w-5/12 lg:6/12 h-full flex justify-start items-center"
      >
        <div
          class="flex justify-center items-center px-3 py-3 bg-white rounded-3xl"
        >
          <div
            class="h-full flex justify-center items-center bg-very-pale-orange rounded-2xl shadow-sc-box p-11"
          >
            <ul
              class="list-none h-full flex flex-col justify-center items-start"
            >
              <li
                class="flex flex-row 2xl:mt-3 lg:mt-1 first:mt-0"
                v-for="(item, index) in guildRework3"
                :key="index"
              >
                <span
                  v-if="item.order"
                  class="bg-vivid-pink 2xl:w-3.5 2xl:h-3.5 lg:w-2.8 lg:h-2.8 font-mulish-bold 2xl:text-1.8 lg:text-1.4 text-white flex justify-center items-center rounded-2xl"
                  v-html="item.order"
                ></span>
                <p
                  :class="
                    item.order ? 'text-very-dark-gray' : 'text-strong-red'
                  "
                  class="pt-2 ml-5 font-mulish-semibold 4xl:text-2 2xl:text-1.8 lg:text-1.4 2xl:leading-2.2 lg:leading-tight"
                  v-html="item.desc"
                ></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
      guildRework3: state => state.SystemChanges.guildRework3,
    }),
  },
};
</script>

<style></style>
